
    <ng-container *ngIf="! standalone">
      <div class="form-group">
        <div class="d-flex d-flex-gap">
          <fieldmagic-text
            purpose="input"
            [content]="label"
            [withRequiredMarker]="withRequiredMarker"
          >
          </fieldmagic-text>

          <fieldmagic-icon
            *ngIf="tooltip | filled"
            icon="info-circle"
            [tooltip]="tooltip"
          >
          </fieldmagic-icon>
        </div>
        <ng-container *ngTemplateOutlet="input"></ng-container>
      </div>
    </ng-container>
    <ng-container
      *ngIf="standalone"
      [ngTemplateOutlet]="input"
    >
    </ng-container>
    <ng-template #input>
      <div class="row">
        <ng-select
          class="col-lg-12 col-md-12 col-xs-12 fieldmagic-multitext"
          [(ngModel)]="values"
          [addTag]="onTagCreation"
          [isOpen]="false"
          [multiple]="true"
          (change)=onChanged($event)
          (focus)="onTouched()"
          bindLabel="0"
          (blur)="onBlur($event.target)"
          (keyup.enter)="onEnter($event.target)"
          [placeholder]="placeholder | translate"
          [class.fieldmagic-input-has-error]="errors | filled"
          [class.fieldmagic-multitext-variant-success]="variant == 'success'"
          [class.fieldmagic-multitext-variant-error]="variant == 'error'"
          [class.fieldmagic-multitext-variant-warning]="variant == 'warning'"
        >
                  <!-- displayed for the selected dropdown option -->
          <ng-template
            ng-label-tmp
            let-item="item"
            let-clear="clear"
          >
            <span class="ng-value-label">{{ item }}</span>
            <span
              class="ng-value-icon right selected-close d-flex align-items-center"
              (click)="clear(item)"
            >
              x
            </span>
          </ng-template>
        </ng-select>

        <div
          fieldmagicGridColumn="12"
        >
          <fieldmagic-input-errors
            *ngIf="errors | filled"
            [errors]="errors">
          </fieldmagic-input-errors>
        </div>
      </div>
    </ng-template>
